// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"377":"838305a6","391":"233643f7","670":"1a05f368"}[chunkId] + ".chunk.css";
};